(function () {
  function mainCode($) {
    var categories = [];

    $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
      categories = [];

      if (data.categories) {
        for (var i = 0; i < data.categories.length; i++) {
          categories.push(data.categories[i]);
        }
      }
    });

    $(document).on('Searchanise.AutocompleteUpdated', function(event, input, ac_results) {
      if (categories) {
        for (var k = 0; k < categories.length; k++) {
          var category = categories[k];
          var el = $('.snize-ac-results .snize-category a[href="'+category.link+'"]');

          if (!$('.snize-thumbnail', el).length && !$('.snize-overhidden', el).length) {
            if (category.image_link) {
              el.html('<span class="snize-thumbnail"><img src="'+category.image_link+'" class="snize-item-image " style="max-width:70px;max-height:70px;" alt="" border="0"></span><span class="snize-overhidden"><span class="snize-title">'+category.title+'</span></span>');
            } else {
              el.html('<span class="snize-overhidden"><span class="snize-title">'+category.title+'</span></span>');
            }
          }
        }
      }
    });
  }

  function waitUntilDefined() {
    if (typeof Searchanise !== "undefined" && typeof Searchanise.$ !== "undefined") {
      mainCode(Searchanise.$);
    } else {
      setTimeout(waitUntilDefined, 50);
    }
  }
  waitUntilDefined();
})();